module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingResult/images/landing-result-award_small.1a8fc158.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingResult/images/landing-result-award_small.png
// module id = 3143
// module chunks = 11